module.exports = "<template> <button type=button class=\"btn btn-cancel waves-effect waves-dark\" data-dismiss=modal> <slot></slot> </button> </template> ";